import { AccountData } from '@types';
import { AccountDetailsTypeformActionButton } from './AccountDetailsTypeformActionButton';

// eslint-disable-next-line  @typescript-eslint/no-unsafe-assignment
const FORM_ID: string = (import.meta.env || process.env)
  ?.VITE_TYPEFORM_CHURN_NOTICE;

export function ChurnNoticeButton({ clientData }: { clientData: AccountData }) {
  return (
    <AccountDetailsTypeformActionButton
      clientData={clientData}
      formId={FORM_ID}
      endpoint='clients/churnRiskSubmitted'
      buttonText='Churn Notice'
      buttonKey='churn_notice-button'
      errorMessage='There was an error saving the Churn Notice. Try again or contact the system administrator.'
      extraHiddenProps={{ role: 'Internal' }}
    />
  );
}
